<template>
  <!-- 成交明细 -->
  <div>
    <div class="report_title">
      <label class="report-line" />
      <span class="report-title">成交明细</span>
      <exportConfig
        :all-head="allHead"
        :header-name="headerName"
      />
    </div>
    <el-table :data="tableData">
      <el-table-column
        fixed
        label="序号"
        align="center"
        width="70px"
      >
        <template slot-scope="scope">
          {{ scope.$index+1 }}
        </template>
      </el-table-column>
      <af-table-column
        fixed
        prop="tradeUserAccount"
        label="客户号"
      />
      <af-table-column
        fixed
        prop="businessNo"
        label="成交编号"
      />
      <af-table-column
        fixed
        prop="businessTime"
        label="时间"
      />
      <af-table-column
        prop="goodsCode"
        label="购销计划"
      />
      <af-table-column
        prop="businessAmount"
        label="数量(笔)"
      />
      <af-table-column
        prop="dayTradeAmount"
        label="变今单量(笔)"
      />
      <af-table-column
        prop="positionTypeDesc"
        label="属性"
      />
      <af-table-column
        prop="entrustTsDesc"
        label="订/变"
      />
      <af-table-column
        prop="entrustBsDesc"
        label="购/销"
      />
      <af-table-column
        prop="businessPrice"
        label="价格"
      />
      <af-table-column
        prop="closeProfit"
        label="预计当日补偿金"
      />
      <af-table-column
        prop="tradeCompanyCode"
        label="贸易公司"
      />
    </el-table>
    <MoreData
      :all-data="allData"
      :table-data.sync="tableData"
    />
  </div>
</template>
<script>
import api from '@/api'
import MoreData from '@/components/more-data'
import exportConfig from '@/components/exportConfig'

export default {
  name: 'TransactionDetails',
  components: {
    MoreData,
    exportConfig,
  },
  props: {
    query: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      allHead: [{
        fieldLabel: '客户号',
        excelColumn: 'tradeUserAccount'
      },
      {
        fieldLabel: '成交编号',
        excelColumn: 'businessNo'
      },
      {
        fieldLabel: '时间',
        excelColumn: 'businessTime'
      },
      {
        fieldLabel: '购销计划',
        excelColumn: 'goodsCode'
      },
      {
        fieldLabel: '数量(笔)',
        excelColumn: 'businessAmount'
      },
      {
        fieldLabel: '变今单量(笔)',
        excelColumn: 'dayTradeAmount'
      },
      {
        fieldLabel: '属性',
        excelColumn: 'positionTypeDesc'
      },
      {
        fieldLabel: '订/变',
        excelColumn: 'entrustTsDesc'
      },
      {
        fieldLabel: '购/销',
        excelColumn: 'entrustBsDesc'
      },
      {
        fieldLabel: '价格',
        excelColumn: 'businessPrice'
      },
      {
        fieldLabel: '预计当日补偿金',
        excelColumn: 'closeProfit'
      },
      {
        fieldLabel: '贸易公司',
        excelColumn: 'tradeCompanyCode'
      },
      ],
      currentPage: 1,
      total: 0,
      pageSize: 10,

      tableData: [], // 表格数据
      allData: [],
      headerName: '购销计划一览表_成交明细',

    }
  },
  methods: {
    // 分页查询
    async fetchList (currentPage, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.currentPage = currentPage || this.currentPage || 1
      let param = {
        ...this.query,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      param.tradingDay = param.date ? this.$dayjs(this.query.date).format('YYYYMMDD')
        : '' // 默认时间，不附带时间将会返回所有数据，而且连分页都没做
      let res = await api.spotPurchaseSaleInquiry.TransactionDetails(param)
      this.allData = res.data || []
    },
  }
}

</script>
